<div class="marv_input_file"
    [class.no_margin]="this.noMargin"
    [class.disabled]="this.disabled"    
    >
    
    @if(this.iconInput !== ''){
        <ion-icon class="marv_input_file_icon_prefix" [name]="this.iconInput"></ion-icon>
    }
    
    <div class="marv_input_file_trigger" (click)="this.selectFile()">
        @if(this.showBtnClearInput 
            && ( (this.formGroupDirective.form.controls[this.formName] && this.formGroupDirective.form.controls[this.formName].value && this.formGroupDirective.form.controls[this.formName].value != '') 
                || (this.file && this.file.url && this.file.url !== '') )
            ){
            <ion-icon class="marv_input_file_icon_sufix" name="close-circle-outline" (click)="this.clearInput($event)"></ion-icon>
        } 
    </div>
    
    @if(this.isRequired){
        <div class="marv_input_required">*</div>
    }
    
    @if(this.fixedLabel){
        <div class="marv_input_fixed_label">{{this.labelInput}}</div>
    }
    
    <input 
        type="text" 
        [placeholder]="(!this.fixedLabel ? this.labelInput : '')"         
        autocomplete="off"
        [value]="this.file?.filedata?.name"        
        disabled        
        /> 
    
    <input 
        #marvInputFile
        type="file"      
        [name]="this.formName" 
        [formControlName]="this.formName"
        [accept]="this.getAcceptFiles()"
        (change)="this.onChangeFile($event)"        
        />    
           
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="marv_input_error">{{this.errorText}}</div>
}
